fragment ClosedLeadEmailAutomation on ClosedLeadEmailAutomation {
    id
    emailList {
        id
        name
    }
}
